import { SelectType } from '../types';

export const tipoExportacao: SelectType[] = [
  { label: 'Entradas e Saídas', value: 0 },
  { label: 'Entradas', value: 1 },
  { label: 'Saídas', value: 2 },
  { label: 'Inventário', value: 3 },
];
